import * as _ from 'lodash';
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { Store, select } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AuctionManageService } from 'app/manage-auctions/services/auction-manage/auction-manage.service';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from '../../../core/components/modals/confirm-modal/confirm-modal.component';
import { CampaignTabsService } from 'app/campaign/services';
import { loadAuction, loadItemDetailInfo } from '../../features/auction.actions';
import { selectCurrentAuction, selectCurrentAuctionItem, selectUsersWithFundingSource } from '../../features/auction.selectors';
import { ModalAuctionDetailService } from '../../services/modal-auction-detail/modal-auction-detail.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from 'app/toast/services/toast.service';
@Component({
  selector: 'app-auction-item-details',
  templateUrl: './auction-item-details.component.html',
  styleUrls: ['./auction-item-details.component.scss']
})
export class AuctionItemDetailsComponent implements OnInit {
  destroyRef = inject(DestroyRef)

  @Input() data
  @Output() bidderSelected = new EventEmitter<any>();

  public moment = moment;

  public loadItemParams: any = null;
  public currentBids:any = null;
  public soldItems:any = null;
  public soldCount: number = 0;
  public currentAutoBids:any = null;
  public auctionItem:any = null;
  public auctionStatus:any = null;
  public auctionType:any = null;
  public auctionCampaign: any = null;
  public auctionBidders: any = null;
  public selectedBidder: any = null;
  public step: string = 'bidders';
  public usersWithFundingSourceMap: any = null;

  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  public currentItem$ = this.store.pipe(
    select(selectCurrentAuctionItem),
    takeUntilDestroyed()
  );

  public currentAuctionCampaign$ = this.store.pipe(
    select(selectCurrentAuction),
  )

  private currentUsersWithFundingSource$ = this.store.pipe(
    takeUntilDestroyed(this.destroyRef),
    select(selectUsersWithFundingSource),
  )

  constructor(
    private store: Store,
    private auctionManageService:AuctionManageService,
    private modalService: MdbModalService,
    public tabsService: CampaignTabsService,
    private modalAuctionDetailService: ModalAuctionDetailService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    this.loadItemParams = this.data;
    this.auctionStatus = this.data.status
    this.auctionType = this.data.auctionType

    if(!this.auctionItem){
      this.store.dispatch({
        type: loadItemDetailInfo.type,
        payload: this.loadItemParams
      });
    }

    this.currentItem$.pipe(
      filter(auctionItem => _.isNull(auctionItem) ? false: true)
    ).subscribe((auctionItem)=>{
      this.auctionItem = auctionItem
      this.currentBids = _.isNull(auctionItem.currentBids) ? []: auctionItem.currentBids;
      this.soldItems = _.isNull(auctionItem.soldItems) ? []: auctionItem.soldItems;
      this.soldCount = this.soldItems.length;
      this.currentAutoBids = _.isNull(auctionItem.currentAutoBids) ? []: auctionItem.currentAutoBids;
      window['$']('[data-toggle="tooltip"]').tooltip()
      window['$']('[data-toggle="popover-hover-table"]').tooltip()
    })

    this.currentAuctionCampaign$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((auctionCampaign) => {
      this.auctionCampaign = auctionCampaign;
      this.auctionBidders = this.auctionManageService.getAuctionBidders(this.auctionCampaign)
    })

    this.currentUsersWithFundingSource$.subscribe(usersWithFunding => {
      this.usersWithFundingSourceMap = usersWithFunding;
    })
  }

  seeBidderDetails(bid) {
    this.step = 'details';
    const userId = bid.userId || bid.userInfo.id;
    const selectedBidder = this.auctionBidders.find(item => item.bidInfo.userInfo.id === userId)

    this.selectedBidder = _.cloneDeep(selectedBidder);

    this.bidderSelected.emit(this.selectedBidder);
  }

  close() {
    this.modalAuctionDetailService.close();
  }

  updateDeliveryStatus(transactionId, delivered){
    this.auctionManageService.updateDeliveryStatus(transactionId, delivered).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((result)=>{
      this.auctionItem.soldItems.forEach(element => {
        if(element.transactionId == transactionId){
          element.delivered = result.delivered
          const message = `Marked as ${result.delivered ? 'Delivered' : 'Not Delivered'}`
          this.toastService.show('success', message, {delay: 1500});
        }
      });
    })

    this.store.dispatch({
      type:loadAuction.type,
      payload: this.data.campaignId,
    })
  }

  getNumberStr(number){
    return this.auctionManageService.addCommasToNumber(number)
  }

  deleteAutoBid(autoBidId) {
    var selectedAutoBid = this.auctionItem.currentAutoBids.find(autoBid => autoBid.id == autoBidId)

    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `Remove ${selectedAutoBid.userInfo.name}'s bid of <b>${this.getNumberStr(selectedAutoBid.amount)}</b> permanently`,
        onClose: (status)=>{
          this.modalRef.close()
          if(status){
            this.auctionManageService.deleteAutoBidById(autoBidId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((data:any)=>{
                if(Object.keys(data).includes('success')){
                  this.currentAutoBids = this.currentAutoBids.filter(autoBid => autoBid.id !== autoBidId)
                  this.store.dispatch({
                    type:loadAuction.type,
                    payload: this.data.campaignId,
                  })
                } else{
                  if(data.errorCode == "AuctionClosed") {
                    this.toastService.show('danger', 'Cannot delete, Auction has already ended', {delay: 1500});
                  } else {
                    this.toastService.show('danger', data.errorMessage, {delay: 1500});
                  }
                }
              })
          }
        }
      }
    });
  }
}
